<div class="header">
    <div class="logo">
        <a [routerLink]="['/dashboard']">
            <app-logo></app-logo>
        </a>
    </div>
    <div class="right-container">
        <div class="language-dropdown">
            <div class="selected-language" (click)="toggleLanguageDropdown()">
                <span class="flag-emoji">{{ getFlagEmoji(getCurrentLanguageCode()) }}</span>
                <span class="language-text desktop-only">{{ currentLanguage }}</span>
                <svg class="desktop-only" width="10" height="5" viewBox="0 0 10 5" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0L5 5L10 0H0Z" fill="#C7C7C7" />
                </svg>
            </div>
            <div class="language-dropdown-menu" *ngIf="showLanguageDropdown">
                <div class="language-item" *ngFor="let lang of languages" (click)="selectLanguage(lang.code)"
                    [class.active]="getCurrentLanguageCode() === lang.code">
                    <span class="flag-emoji">{{ getFlagEmoji(lang.code) }}</span>
                    <span class="desktop-only">{{ lang.name }}</span>
                </div>
            </div>
        </div>
        <div class="user-info" *ngIf="user">
            <div class="user-info-icon">
                <app-profile-icon></app-profile-icon>
                <span class="user-name">{{user?.email}}</span>
            </div>
            <div class="user-info-actions" (click)="logout()">
                <span class="user-info-action">{{ 'Menu.logout' | translate }}</span>
                <app-logout-icon></app-logout-icon>
            </div>
        </div>
    </div>
</div>